"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultPreviewImage = exports.PlayerWrapper = exports.MediaVideoWrapper = exports.ExternalMediaLink = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const fdr_regular_basis_fdr_image_1 = require("@hotelplan/fdr.regular.basis.fdr-image");
const fdr_regular_basis_fdr_route_1 = require("@hotelplan/fdr.regular.basis.fdr-route");
exports.ExternalMediaLink = (0, styled_components_1.default)(fdr_regular_basis_fdr_route_1.FdrRoute)({
    width: '100%',
    height: '100%',
    pointerEvents: 'all',
});
exports.MediaVideoWrapper = styled_components_1.default.div(({ fullScreen }) => (Object.assign({ position: 'relative', width: '100%', height: '100%' }, (fullScreen && {
    position: 'absolute',
    top: 0,
    left: 0,
    '.slide': {
        position: 'relative',
    },
}))));
exports.PlayerWrapper = styled_components_1.default.div(({ fullScreen, aspectRatio }) => (Object.assign({ position: 'absolute', width: '100%', height: '100%', top: 0, left: 0 }, (fullScreen && {
    position: 'relative',
    paddingTop: `${aspectRatio * 100}%`,
    width: 'initial',
    height: 'initial',
    top: 'initial',
    left: 'initial',
    '.react-player': {
        position: 'absolute',
        top: 0,
        left: 0,
    },
}))));
exports.DefaultPreviewImage = (0, styled_components_1.default)(fdr_regular_basis_fdr_image_1.FdrImage)({
    width: '100%',
    height: '100%',
    pointerEvents: 'none',
    alignSelf: 'center',
    objectFit: 'cover',
});
//# sourceMappingURL=fdr-media.styles.js.map